import formatQuery from 'utils/formatQuery'
import {getCurrentUser} from '../modules/currentUser/selectors'
const BASE_URL = __API_URL__

const loggedActions = [
  '@@redux-form/FOCUS',
  '@@redux-form/BLUR',
  'STORE_WIZARD_DATA'
]

const loggedForms = ['wizard', 'wizard-mappings']

function isFormAction(action) {
  return action.meta && action.meta.form
}

function isLoggableForm(action) {
  return loggedForms.includes(action.meta.form)
}

function shouldActionBeLogged(action, state) {
  const actionName = action.type

  if (isFormAction(action) && !isLoggableForm(action)) return false

  const currentUser = getCurrentUser(state)

  if (currentUser && currentUser.roles && currentUser.roles.includes('admin')) return false

  return loggedActions.includes(actionName)
}

function getActionData(action, state) {
  if (isFormAction(action)) {
    const formName = action.meta.form
    let values = (state.form[formName] && state.form[formName].values) || {}

    if (action.meta.field && action.payload) {
      values = {
        ...values,
        [action.meta.field]: action.payload
      }
    }

    return {
      storageKey: `form_${formName}`,
      data: values
    }
  } else {
    return {
      storageKey: action.storageKey,
      data: action.data
    }
  }
}

export default store => next => action => {
  const state = store.getState()
  if (shouldActionBeLogged(action, state)) {
    const queryParams = {
      access_token: state.currentUser.token
    }
    fetch(`${BASE_URL}user/storage?${formatQuery(queryParams)}`, {
      headers: {
        'Accept': 'application/vnd.divvit.v2+json',
        'Content-Type': 'application/json;charset=UTF-8'
      },
      method: 'PATCH',
      body: JSON.stringify(getActionData(action, state))
    })
  }

  return next(action)
}



// WEBPACK FOOTER //
// ./client/redux/middleware/stateSaver.js